<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import BlankLayout from '@/layouts/BlankLayout.vue';

const route = useRoute();
const isBlank = computed(() => route.meta.layout === 'blank');
</script>

<template>
  <BlankLayout v-if="isBlank">
    <RouterView />
  </BlankLayout>
  <DefaultLayout v-else>
    <RouterView />
  </DefaultLayout>
</template>
